import {
  Component,
  Inject,
  OnInit,
  AfterViewInit,
  QueryList,
  ViewChildren,
  ElementRef,
  ViewChild,
  inject,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MeterService } from '@feature/meter';
import { DialogService, SessionStore, ToastService } from '@core';
import { Tenants } from '../../interface/tenants';
import {
  combineLatest,
  defer,
  filter,
  forkJoin,
  map,
  merge,
  Observable,
  of,
  startWith,
  switchMap,
} from 'rxjs';
import { Loops } from '../../interface/loops';
import { Tags } from '../../interface/tags';
import { Panels } from '../../interface/panels';
import {
  MatAutocompleteSelectedEvent,
  MatAutocompleteTrigger,
} from '@angular/material/autocomplete';
import { LocationTierKey } from '@contracts';
import { MeterCompare, MeterFormKeys } from '../../data-access/meter.type';
import { UpdateNewMeter } from '../../interface/meter';

@Component({
  selector: 'app-manage-meter-modal',
  templateUrl: './manage-meter-modal.component.html',
  styleUrls: ['./manage-meter-modal.component.scss'],
})
export class ManageMeterModalComponent implements OnInit, AfterViewInit {
  @ViewChildren('inputRef') inputs!: QueryList<ElementRef>;

  data: any;
  isEditMode = false;
  originalData: any = {};
  panels_list: Panels[] = [];
  tags_list: Tags[] = [];
  tenants_list: Tenants[] = [];
  loops_list: Loops[] = [];
  group_list: any[] = [];
  brand_list: any[] = [];
  unit_list: any[] = [];
  tagCtrl = new FormControl('');
  filteredTags!: Observable<Tags[]>;
  separatorKeysCodes: number[] = [13, 188];
  allLocations: any[] = [];

  locationList: Record<LocationTierKey, string[]> = {
    location_tier_1: [],
    location_tier_2: [],
    location_tier_3: [],
    location_tier_4: [],
    location_tier_5: [],
  };

  filteredLocationList: Record<LocationTierKey, string[]> = {
    location_tier_1: [],
    location_tier_2: [],
    location_tier_3: [],
    location_tier_4: [],
    location_tier_5: [],
  };
  filteredOptionsTenant: Observable<Tenants[]>;
  private sessionStore = inject(SessionStore);

  private initialFormValue: any;
  private draftKey = '';
  tenantSearchCtrl = new FormControl('');
  filteredtenant$!: Observable<string[]>;

  modelSearchCtrl = new FormControl('');
  filteredModels$!: Observable<any[]>;

  brandSearchCtrl = new FormControl('');
  filteredBrands$!: Observable<string[]>;

  loopSearchCtrl = new FormControl('');
  filteredLoop$!: Observable<any[]>;

  locationTier1SearchCtrl = new FormControl('');
  filteredlocationTier1$!: Observable<any[]>;

  locationTier2SearchCtrl = new FormControl('');
  filteredlocationTier2$!: Observable<string[]>;

  locationTier3SearchCtrl = new FormControl('');
  filteredlocationTier3$!: Observable<any[]>;

  locationTier4SearchCtrl = new FormControl('');
  filteredlocationTier4$!: Observable<string[]>;

  locationTier5SearchCtrl = new FormControl('');
  filteredlocationTier5$!: Observable<string[]>;

  panelSearchCtrl = new FormControl('');
  filteredPanels$!: Observable<Panels[]>;
  formMeter = new FormGroup({
    name: new FormControl('', Validators.required),
    meter_id: new FormControl<number | null>(null, Validators.required),
    brand: new FormControl('', Validators.required),
    model: new FormControl(''),
    serial_number: new FormControl(''),
    tenant_name: new FormControl(''),
    conv_ip: new FormControl('', Validators.required),
    port: new FormControl('', Validators.required),
    sub_meter_id: new FormControl(''),
    sensor_type: new FormControl('energy'),
    loop: new FormControl(''),
    module: new FormControl(this.sessionStore.getModule()),

    location_tier_1: new FormControl<string | null>(null),
    location_tier_2: new FormControl<string | null>(null),
    location_tier_3: new FormControl<string | null>(null),
    location_tier_4: new FormControl<string | null>(null),
    location_tier_5: new FormControl<string | null>(null),

    description: new FormControl(''),

    loop_name: new FormControl(''),
    panel: new FormControl(),
    type: new FormControl(''),

    tags: new FormControl<any[]>([]),
  });

  @ViewChild(MatAutocompleteTrigger) autocomplete!: MatAutocompleteTrigger;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public payload: {
      data: any;
      editMode?: boolean;
    },
    private dialogRef: MatDialogRef<ManageMeterModalComponent>,
    private meterService: MeterService,
    private toast: ToastService,
    public dialog: DialogService,
  ) {
    this.filteredOptionsTenant =
      this.formMeter.controls.tenant_name.valueChanges.pipe(
        startWith(this.formMeter.value.tenant_name),
        map((search) => {
          const keyword = (search || '').toLowerCase();
          const selected = this.formMeter.value.tenant_name;

          return this.tenants_list.filter((option) => {
            if (option.name === selected) return true;
            return option.name.toLowerCase().includes(keyword);
          });
        }),
      );

    this.data = payload.data;

    this.isEditMode = payload.editMode ?? false;
  }
  initLoopFilter() {
    this.filteredLoop$ = combineLatest([
      this.loopSearchCtrl.valueChanges.pipe(startWith('')),
      defer(() => of(this.getDefalutLoop)),
      this.formMeter
        .get('loop_name')!
        .valueChanges.pipe(startWith(this.formMeter.value.loop_name)),
    ]).pipe(
      map(([search, list, selected]) => {
        const keyword = (search || '').toLowerCase();

        return list.filter((loop) => {
          if (loop === selected) return true;
          return loop.toLowerCase().includes(keyword);
        });
      }),
    );
  }
  initPanelFilter() {
    this.filteredPanels$ = combineLatest([
      this.panelSearchCtrl.valueChanges.pipe(startWith('')),
      of(this.panels_list),
      this.formMeter
        .get('panel')!
        .valueChanges.pipe(startWith(this.formMeter.value.panel)),
    ]).pipe(
      map(([search, list, selected]) => {
        const keyword = (search || '').toLowerCase();

        return list.filter((panel) => {
          const name = panel.panel_tier_5?.toLowerCase?.() || '';
          const match = name.includes(keyword);
          const notSelected = String(panel.id) !== selected;
          return match && notSelected;
        });
      }),
    );
  }
  initModelFilter() {
    this.filteredModels$ = combineLatest([
      this.modelSearchCtrl.valueChanges.pipe(startWith('')),
      this.formMeter
        .get('brand')!
        .valueChanges.pipe(startWith(this.formMeter.value.brand)),
      this.formMeter
        .get('model')!
        .valueChanges.pipe(startWith(this.formMeter.value.model)),
      of(this.brand_list),
    ]).pipe(
      map(([search, brand, selected, list]) => {
        const keyword = (search || '').toLowerCase();

        return list
          .filter((b) => b.name === brand)
          .filter((item) => {
            if (item.id === selected) return true;
            return item.model.toLowerCase().includes(keyword);
          })
          .sort((a, b) => a.model.localeCompare(b.model));
      }),
    );
  }

  initLocationTier1Filter() {
    this.filteredlocationTier1$ = combineLatest([
      this.locationTier1SearchCtrl.valueChanges.pipe(startWith('')),
      this.formMeter
        .get('location_tier_1')!
        .valueChanges.pipe(startWith(this.formMeter.value.location_tier_1)),
      of(this.locationList.location_tier_1),
    ]).pipe(
      map(([search, selected, list]) => {
        const keyword = (search || '').toLowerCase();

        return list.filter((item) => {
          if (item === selected) return true;
          return item.toLowerCase().includes(keyword);
        });
      }),
    );
  }

  initLocationTier2Filter() {
    this.filteredlocationTier2$ = combineLatest([
      this.locationTier2SearchCtrl.valueChanges.pipe(startWith('')),
      this.formMeter
        .get('location_tier_1')!
        .valueChanges.pipe(startWith(this.formMeter.value.location_tier_1)),
      this.formMeter
        .get('location_tier_2')!
        .valueChanges.pipe(startWith(this.formMeter.value.location_tier_2)),
      of(this.allLocations),
    ]).pipe(
      map(([search, tier1, selected, list]) => {
        const keyword = (search || '').toLowerCase();

        const options = [
          ...new Set(
            list
              .filter((d) => d.location_tier_1 === tier1)
              .map((d) => d.location_tier_2)
              .filter(Boolean),
          ),
        ];

        return options.filter((item) => {
          if (item === selected) return true; // ค่าที่เลือกไว้ให้แสดงเสมอ
          return item.toLowerCase().includes(keyword);
        });
      }),
    );
  }

  initLocationTier3Filter() {
    this.filteredlocationTier3$ = combineLatest([
      this.locationTier3SearchCtrl.valueChanges.pipe(startWith('')),
      this.formMeter
        .get('location_tier_2')!
        .valueChanges.pipe(startWith(this.formMeter.value.location_tier_2)),
      this.formMeter
        .get('location_tier_3')!
        .valueChanges.pipe(startWith(this.formMeter.value.location_tier_3)),
      of(this.allLocations),
    ]).pipe(
      map(([search, tier2, selected, list]) => {
        const keyword = (search || '').toLowerCase();

        const options = [
          ...new Set(
            list
              .filter((d) => d.location_tier_2 === tier2)
              .map((d) => d.location_tier_3)
              .filter(Boolean),
          ),
        ];

        return options.filter((item) => {
          if (item === selected) return true;
          return item.toLowerCase().includes(keyword);
        });
      }),
    );
  }

  initLocationTier4Filter() {
    this.filteredlocationTier4$ = combineLatest([
      this.locationTier4SearchCtrl.valueChanges.pipe(startWith('')),
      this.formMeter
        .get('location_tier_3')!
        .valueChanges.pipe(startWith(this.formMeter.value.location_tier_3)),
      this.formMeter
        .get('location_tier_4')!
        .valueChanges.pipe(startWith(this.formMeter.value.location_tier_4)),
      of(this.allLocations),
    ]).pipe(
      map(([search, tier3, selected, list]) => {
        const keyword = (search || '').toLowerCase();

        const options = [
          ...new Set(
            list
              .filter((d) => d.location_tier_3 === tier3)
              .map((d) => d.location_tier_4)
              .filter(Boolean),
          ),
        ];

        return options.filter((item) => {
          if (item === selected) return true;
          return item.toLowerCase().includes(keyword);
        });
      }),
    );
  }

  initLocationTier5Filter() {
    this.filteredlocationTier5$ = combineLatest([
      this.locationTier5SearchCtrl.valueChanges.pipe(startWith('')),
      this.formMeter
        .get('location_tier_3')!
        .valueChanges.pipe(startWith(this.formMeter.value.location_tier_3)),
      this.formMeter
        .get('location_tier_4')!
        .valueChanges.pipe(startWith(this.formMeter.value.location_tier_4)),
      this.formMeter
        .get('location_tier_5')!
        .valueChanges.pipe(startWith(this.formMeter.value.location_tier_5)),
      of(this.allLocations),
    ]).pipe(
      map(([search, tier3, tier4, selected, list]) => {
        const keyword = (search || '').toLowerCase();
        const options = [
          ...new Set(
            list
              .filter(
                (d) =>
                  d.location_tier_3 === tier3 && d.location_tier_4 === tier4,
              )
              .map((d) => d.location_tier_5)
              .filter(Boolean),
          ),
        ];

        return options.filter((item) => {
          if (item === selected) return true;
          return item.toLowerCase().includes(keyword);
        });
      }),
    );
  }
  ngOnInit(): void {
    this.originalData = { ...this.data };
    this.loadLovData();

    this.filteredBrands$ = this.brandSearchCtrl.valueChanges.pipe(
      startWith(''),
      map((search) => {
        const keyword = (search || '').toLowerCase();
        const selected = this.formMeter.get('brand')?.value;

        const filtered = this.get_brand.filter((item) =>
          item.toLowerCase().includes(keyword),
        );

        if (selected && !filtered.includes(selected)) {
          return [selected, ...filtered];
        }

        return filtered;
      }),
    );

    this.filteredTags = merge(
      this.tagCtrl.valueChanges,
      this.formMeter.get('tags')!.valueChanges,
    ).pipe(
      startWith(''),
      map(() => this._filterTags(this.tagCtrl.value || '')),
    );
    if (
      !this.isLocationTier4Enabled() ||
      !this.formMeter.get('location_tier_3')?.value
    ) {
      this.formMeter.get('location_tier_4')?.disable();
    } else {
      this.formMeter.get('location_tier_4')?.enable();
    }

    if (!this.isPanelTier5Enabled()) this.formMeter.get('panel')?.disable();
    else this.formMeter.get('panel')?.enable();

    this.formMeter.get('location_tier_1')!.valueChanges.subscribe((tier1) => {
      const tier2List = [
        ...new Set(
          this.allLocations
            .filter((d) => d.location_tier_1 === tier1)
            .map((d) => d.location_tier_2)
            .filter(Boolean),
        ),
      ];

      this.locationList.location_tier_2 = tier2List;

      this.formMeter.patchValue(
        {
          location_tier_2: null,
          location_tier_3: null,
          location_tier_4: null,
          location_tier_5: null,
        },
        { emitEvent: false },
      );
    });
    this.formMeter.get('location_tier_2')!.valueChanges.subscribe((tier2) => {
      const tier3List = [
        ...new Set(
          this.allLocations
            .filter((d) => d.location_tier_2 === tier2)
            .map((d) => d.location_tier_3)
            .filter(Boolean),
        ),
      ];

      this.locationList.location_tier_3 = tier3List;

      this.formMeter.patchValue(
        {
          location_tier_3: null,
          location_tier_4: null,
          location_tier_5: null,
        },
        { emitEvent: false },
      );
    });

    this.formMeter.get('location_tier_3')!.valueChanges.subscribe((tier3) => {
      const tier4Control = this.formMeter.get('location_tier_4');
      const tier4List = [
        ...new Set(
          this.allLocations
            .filter((d) => d.location_tier_3 === tier3)
            .map((d) => d.location_tier_4)
            .filter(Boolean),
        ),
      ];

      this.locationList.location_tier_4 = tier4List;

      this.formMeter.patchValue(
        {
          location_tier_4: null,
          location_tier_5: null,
        },
        { emitEvent: false },
      );

      if (this.isLocationTier4Enabled() || tier3) {
        tier4Control?.enable({ emitEvent: false });
      } else {
        tier4Control?.disable({ emitEvent: false });
      }
    });
    this.formMeter.get('location_tier_4')!.valueChanges.subscribe((tier4) => {
      const tier5List = [
        ...new Set(
          this.allLocations
            .filter((d) => d.location_tier_4 === tier4)
            .map((d) => d.location_tier_5)
            .filter(Boolean),
        ),
      ];

      this.locationList.location_tier_5 = tier5List;

      this.formMeter.patchValue(
        {
          location_tier_5: null,
        },
        { emitEvent: false },
      );

      const tier5Control = this.formMeter.get('location_tier_5');
      if (tier4) {
        tier5Control?.enable({ emitEvent: false });
      } else {
        tier5Control?.disable({ emitEvent: false });
      }
    });
  }

  ngAfterViewInit() {
    this.focusFirstEdited();
  }

  get test_sync_button_check(): boolean {
    try {
      let formMeter = this.originalData;
      let get_bran_selected = this.get_bran_selected;

      if (
        formMeter.conv_ip &&
        formMeter.meter_id &&
        formMeter.port &&
        get_bran_selected.model &&
        get_bran_selected.name
      ) {
        return true;
      }
    } catch (error) {}
    return false;
  }

  test_sync_click() {
    this.sync_data = null;
    let formMeter = this.originalData;
    let get_bran_selected = this.get_bran_selected;
    this.meterTestSync({
      conv_ip: formMeter.conv_ip || '',
      meter_id: formMeter.meter_id || '',
      sub_meter_id: formMeter.sub_meter_id || '',
      port: formMeter.port || '',
      brand: get_bran_selected?.name || '',
      model: get_bran_selected?.model || '',
    });
  }

  meterTestSync(req: {
    conv_ip: string;
    meter_id: string;
    sub_meter_id: string;
    port: string;
    brand: string;
    model: string;
  }) {
    this.dialog.withLoading(this.meterService.meterTestSync(req)).subscribe({
      next: (response) => {
        if (response.meta.response_code == 20000) {
          try {
            this.sync_data = response.meta.response_data;
          } catch (error) {
            console.error(error);
          }
        } else {
          this.toast.error('เกิดข้อผิดพลาด');
        }
      },
      error: (e) => {
        console.error(e);
        this.toast.error('เกิดข้อผิดพลาด');
      },
    });
  }

  sync_data?: {
    online_status: boolean;
    data: string;
    message: string;
  } | null;

  get get_bran_selected(): {
    name: string;
    model: string;
  } {
    try {
      let formMeter = this.originalData;
      let data = this.brand_list.filter((v) => {
        return formMeter.brand_name == v.name;
      });
      if (data[0]) {
        return data[0];
      } else {
        return { name: '', model: '' };
      }
    } catch (error) {
      return { name: '', model: '' };
    }
  }

  patchForm(data: any) {
    const brandModels = this.brand_list.filter(
      (b) => b.name === data.brand_name,
    );
    const modelObj = brandModels.find((m) => m.model === data.model);
    const panelTier5Obj = this.panels_list.find(
      (m) => m.panel_tier_5 === data.panel_tier_5,
    );
    this.formMeter.patchValue(
      {
        name: data?.name || '',
        meter_id: data?.meter_id || null,
        brand: data?.brand_name || '',
        model: modelObj ? modelObj.id : null,
        tenant_name: data?.tenant_name || '',
        type: data?.type || '',
        serial_number: data?.serial_number || '',
        port: data?.port || null,
        conv_ip: data?.conv_ip || null,
        sub_meter_id: data?.sub_meter_id || null,
        location_tier_1: data?.location_tier_1 || null,
        location_tier_2: data?.location_tier_2 || null,
        location_tier_3: data?.location_tier_3 || null,
        location_tier_4: data?.location_tier_4 || null,
        location_tier_5: data?.location_tier_5 || null,
        description: data?.description || '',
        loop_name: data?.loop_name || '',
        // loop_name: data?.loop_name
        //   ? this.loops_list.find((t) => t.name === data?.loop_name)?.id
        //   : '',
        panel: panelTier5Obj ? panelTier5Obj.id : '',
        tags: data?.tags
          ? data.tags
              .map(
                (name: string) =>
                  this.tags_list.find((t) => t.name === name)?.id,
              )
              .filter((id: any): id is number => !!id)
          : [],
      },
      { emitEvent: false },
    );
  }

  openEdit() {
    this.isEditMode = true;
  }

  loadLovData() {
    forkJoin({
      brands: this.meterService.getBrand('public'),
      tags: this.meterService.getTags('public'),
      panels: this.meterService.getPanels('public'),
      locations: this.meterService.getLocations('detail'),
      loops: this.meterService.getLoops('list'),
      tenants: this.meterService.getTenants('public'),
    }).subscribe({
      next: (res) => {
        this.brand_list = res.brands.meta.response_data;
        this.filteredBrands$ = this.brandSearchCtrl.valueChanges.pipe(
          startWith(''),
          map((search) => {
            const keyword = (search || '').toLowerCase();
            const selected = this.formMeter.get('brand')?.value;

            const filtered = this.get_brand.filter((item) =>
              item.toLowerCase().includes(keyword),
            );

            if (selected && !filtered.includes(selected)) {
              return [selected, ...filtered];
            }

            return filtered;
          }),
        );
        this.tags_list = res.tags.meta.response_data;
        this.panels_list = res.panels.meta.response_data;
        this.allLocations = res.locations.meta.response_data;
        this.loops_list = res.loops.meta.response_data;
        this.tenants_list = res.tenants.meta.response_data;
        this.filteredOptionsTenant =
          this.formMeter.controls.tenant_name.valueChanges.pipe(
            startWith(this.formMeter.value.tenant_name),
            map((search) => {
              const keyword = (search || '').toLowerCase();
              const selected = this.formMeter.value.tenant_name;

              return this.tenants_list.filter((option) => {
                if (option.name === selected) return true;
                return option.name.toLowerCase().includes(keyword);
              });
            }),
          );
        this.patchForm(this.originalData);

        this.locationTier1SearchCtrl.setValue('');
        this.locationTier2SearchCtrl.setValue('');
        this.locationTier2SearchCtrl.setValue('');
        this.locationTier3SearchCtrl.setValue('');
        this.locationTier4SearchCtrl.setValue('');
        this.locationTier5SearchCtrl.setValue('');
        this.patchLocation(this.originalData);
        this.initialFormValue = this.formMeter.getRawValue();

        this.buildLocationOptions();

        this.initPanelFilter();
        this.initModelFilter();
        this.initLoopFilter();
        this.initLocationTier1Filter();
        this.initLocationTier2Filter();
        this.initLocationTier3Filter();
        this.initLocationTier4Filter();
        this.initLocationTier5Filter();
      },
      error: (e) => console.error(e),
    });
  }

  closeEdit() {
    this.isEditMode = false;
    this.patchForm(this.originalData);
    this.initialFormValue = this.formMeter.getRawValue();
  }

  close() {
    this.dialogRef.close();
  }

  private isEqual(a: any, b: any): boolean {
    a = this.normalize(a);
    b = this.normalize(b);

    if (a === b) return true;

    if (Array.isArray(a) && Array.isArray(b)) {
      if (a.length !== b.length) return false;
      return a.every((v, i) => this.isEqual(v, b[i]));
    }

    if (typeof a === 'object' && typeof b === 'object') {
      if (!a || !b) return false;

      const keysA = Object.keys(a);
      const keysB = Object.keys(b);

      if (keysA.length !== keysB.length) return false;

      return keysA.every((k) => this.isEqual(a[k], b[k]));
    }

    return false;
  }

  getOriginalCompare(): MeterCompare {
    const brandModels = this.brand_list.filter(
      (b) => b.name === this.originalData.brand_name,
    );

    const modelObj = brandModels.find(
      (m) => m.model === this.originalData.model,
    );

    return {
      name: this.originalData.name,
      meter_id: this.originalData.meter_id,
      sub_meter_id: this.originalData.sub_meter_id,
      brand: this.originalData.brand_name,
      model: modelObj ? modelObj.id : null,
      tenant_name: this.originalData.tenant_name,
      serial_number: this.originalData.serial_number,
      type: this.originalData.type,
      module: this.originalData.module,
      location_tier_1: this.originalData.location_tier_1,
      location_tier_2: this.originalData.location_tier_2,
      location_tier_3: this.originalData.location_tier_3,
      location_tier_4: this.originalData.location_tier_4,
      location_tier_5: this.originalData.location_tier_5,
      description: this.originalData.description,
      loop_name: this.originalData.loop_name,
      panel: this.originalData.panel_tier_2 || this.originalData.panel,
      tags: this.originalData.tags
        ? this.originalData.tags
            .map(
              (name: string) => this.tags_list.find((t) => t.name === name)?.id,
            )
            .filter((id: any): id is number => !!id)
        : [],
    };
  }

  getDiff() {
    if (!this.initialFormValue) return [];

    const current = this.formMeter.getRawValue();

    return (Object.keys(this.initialFormValue) as MeterFormKeys[])
      .filter((key) => !this.isEqual(this.initialFormValue[key], current[key]))
      .map((key) => ({
        field: key,
        old: this.initialFormValue[key],
        new: current[key],
      }));
  }

  get isChanged(): boolean {
    return this.getDiff().length > 0;
  }

  get isDirty(): boolean {
    return this.isChanged;
  }

  isEdited(field: MeterFormKeys): boolean {
    return this.getDiff().some((d) => d.field === field);
  }

  undoAll() {
    this.patchForm(this.originalData);
    this.initialFormValue = this.formMeter.getRawValue();
  }

  undoField(field: MeterFormKeys) {
    const original = this.getOriginalCompare()[field];

    this.formMeter.patchValue({ [field]: original });
  }

  focusFirstEdited() {
    const first = this.getDiff()[0];
    if (!first) return;

    const el = document.querySelector(
      `[formcontrolname="${first.field}"]`,
    ) as HTMLElement;

    el?.focus();
  }

  addTag(event: any) {
    const value = (event.value || '').trim();
    if (!value) return;

    const current = this.formMeter.value.tags || [];

    this.formMeter.patchValue({
      tags: [...current, value],
    });

    event.chipInput?.clear();
  }

  private normalize(value: any): any {
    if (value === null || value === undefined || value === '') {
      return null;
    }

    return typeof value === 'string' ? value.trim() : value;
  }

  private getSelectedLocationId(): number | null {
    const {
      location_tier_1,
      location_tier_2,
      location_tier_3,
      location_tier_4,
      location_tier_5,
    } = this.formMeter.value;

    const found = this.allLocations.find(
      (loc) =>
        this.normalize(loc.location_tier_1) ===
          this.normalize(location_tier_1) &&
        this.normalize(loc.location_tier_2) ===
          this.normalize(location_tier_2) &&
        this.normalize(loc.location_tier_3) ===
          this.normalize(location_tier_3) &&
        this.normalize(loc.location_tier_4) ===
          this.normalize(location_tier_4) &&
        this.normalize(loc.location_tier_5) === this.normalize(location_tier_5),
    );

    return found?.id ?? null;
  }

  openConfirm() {
    const diff = this.getDiff();

    if (!diff.length) return;

    const payload = this.buildPayload();

    this.dialog
      .confirm({
        title: 'view_value.confirm_update',
        message: 'view_value.confirm_change_values',
        diff: diff,

        confirm: {
          text: 'view_value.save',
          variant: 'primary',
        },
        cancel: {
          text: 'view_value.cancel',
        },
      })
      .pipe(
        filter(Boolean),
        switchMap(() => this.meterService.updateMeter(payload)),
      )
      .subscribe({
        next: () => {
          this.toast.success('Updated!');
          this.dialogRef.close('updated');
        },
        error: () => {
          this.toast.error('Update failed');
        },
      });
  }

  isLocationTier4Enabled(): boolean {
    const value = this.sessionStore.getDictionariesValidate()?.location_tier_4;
    return value;
  }

  isPanelTier5Enabled(): boolean {
    const value = this.sessionStore.getDictionariesValidate()?.panel_tier_5;
    return value !== null && value !== undefined && value !== '';
  }

  loadPublicUnit() {
    this.dialog.withLoading(this.meterService.getPublicUnit()).subscribe({
      next: (response) => {
        if (response.meta.response_code == 20000) {
          try {
            this.unit_list = response.meta.response_data;
          } catch (error) {
            console.error(error);
          }
        }
      },
      error: (e) => {
        console.error(e);
      },
    });
  }

  get get_group() {
    let data = this.group_list.map((v) => v.name);
    return data;
  }

  loadGroupList() {
    this.dialog.withLoading(this.meterService.getGroups()).subscribe({
      next: (response) => {
        if (response.meta.response_code == 20000) {
          this.group_list = response.meta.response_data.groups;
        } else {
          alert('Occurred');
        }
      },
      error: (e) => console.error(e),
    });
  }

  private getLocationOptions(
    parentKey: LocationTierKey | null,
    parentValue: string | null | undefined,
    targetKey: LocationTierKey,
  ): string[] {
    if (!parentKey || !parentValue) {
      return [];
    }

    return [
      ...new Set(
        this.allLocations
          .filter((location) => location[parentKey] === parentValue)
          .map((location) => location[targetKey])
          .filter(Boolean),
      ),
    ];
  }

  get get_brand(): string[] {
    return [...new Set(this.brand_list.map((item) => item.name).sort())];
  }

  get getDefalutLoop(): string[] {
    return [...new Set(this.loops_list.map((item) => item.name).sort())];
  }

  get get_model() {
    try {
      let data = this.brand_list
        .filter((v) => v.name == this.formMeter.value.brand)
        .sort((a, b) => {
          if (a.model < b.model) return -1;
          if (a.model > b.model) return 1;
          return 0;
        });
      return data;
    } catch (error) {}
    return [];
  }

  loadBrandList() {
    this.dialog.withLoading(this.meterService.getBrand('public')).subscribe({
      next: (response) => {
        if (response.meta.response_code == 20000) {
          this.brand_list = response.meta.response_data;
        } else {
          // alert('Occurred');
        }
      },
      error: (e) => console.error(e),
    });
  }

  loadPanels() {
    this.dialog.withLoading(this.meterService.getPanels('public')).subscribe({
      next: (response) => {
        if (response.meta.response_code == 20000) {
          try {
            let data = response.meta.response_data;
            this.panels_list = data;
            this.panels_list = this.panels_list.filter((p)=> p.panel_tier_5 != null)
          } catch (error) {
            console.error(error);
          }
        }
      },
      error: (e) => {
        console.error(e);
      },
    });
  }

  buildLocationOptions() {
    const data = this.allLocations;

    this.locationList.location_tier_1 = [
      ...new Set(data.map((d) => d.location_tier_1).filter(Boolean)),
    ];
  }

  loadLocationsData() {
    this.dialog
      .withLoading(this.meterService.getLocations('detail'))
      .subscribe({
        next: (response) => {
          if (response.meta.response_code === 20000) {
            this.allLocations = response.meta.response_data;

            this.buildLocationOptions();

            this.getTier2Options();
            this.getTier3Options();
            this.getTier4Options();
            this.getTier5Options();
          }
        },
        error: (e) => console.error(e),
      });
  }

  getTier2Options() {
    const selected = this.formMeter.value.location_tier_1;
    this.locationList.location_tier_2 = [
      ...new Set(
        this.allLocations
          .filter((d) => d.location_tier_1 === selected)
          .map((d) => d.location_tier_2)
          .filter(Boolean),
      ),
    ];
  }

  private getTier3Options(): void {
    this.locationList.location_tier_3 = this.getLocationOptions(
      'location_tier_2',
      this.formMeter.value.location_tier_2,
      'location_tier_3',
    );
  }

  private getTier4Options(): void {
    this.locationList.location_tier_4 = this.getLocationOptions(
      'location_tier_3',
      this.formMeter.value.location_tier_3,
      'location_tier_4',
    );
  }

  private getTier5Options(): void {
    this.locationList.location_tier_5 = this.getLocationOptions(
      'location_tier_4',
      this.formMeter.value.location_tier_4,
      'location_tier_5',
    );
  }

  loadTags() {
    this.dialog.withLoading(this.meterService.getTags('public')).subscribe({
      next: (response) => {
        if (response.meta.response_code == 20000) {
          try {
            let data = response.meta.response_data;
            this.tags_list = data;
          } catch (error) {
            console.error(error);
          }
        }
      },
      error: (e) => {
        console.error(e);
      },
    });
  }
  private _filterTags(value: string): Tags[] {
    const filterValue = (value || '').toLowerCase();

    const selectedTags: number[] = this.formMeter.get('tags')?.value ?? [];
    return this.tags_list.filter(
      (tag) =>
        tag.name.toLowerCase().includes(filterValue) &&
        !selectedTags.includes(tag.id),
    );
  }

  selectedTag(event: MatAutocompleteSelectedEvent) {
    const selectedTag = this.tags_list.find(
      (t) => t.name === event.option.value,
    );
    if (selectedTag) {
      const current = this.formMeter.value.tags || [];
      this.formMeter.patchValue({ tags: [...current, selectedTag.id] });

      this.tagCtrl.setValue('');
    }
  }

  addTagFromAutocomplete(event: any) {
    if (
      !this.tags_list.some(
        (t) => t.name.toLowerCase() === (event.value || '').toLowerCase(),
      )
    ) {
      this.tagCtrl.setValue('');
      return;
    }
  }

  removeTag(tagId: any) {
    const current = this.formMeter.value.tags || [];
    this.formMeter.patchValue({
      tags: current.filter((t: any) => t !== tagId),
    });

    this.tagCtrl.setValue(this.tagCtrl.value || '');
  }

  getTagName(id: any) {
    const found = this.tags_list.find((t) => t.id === id);
    return found?.name || id;
  }

  get tenants_id_selected() {
    try {
      let tenant_name = this.formMeter.value.tenant_name;
      let tenants_list = this.tenants_list;
      let tenants_select = tenants_list.filter(
        (v) => <string | null>v.name == tenant_name,
      );
      if (tenants_select.length == 1) {
        return tenants_select[0].id;
      }
    } catch (error) {}
    return null;
  }
  openAutocomplete() {
    this.autocomplete.openPanel();
  }

  tenants_id_selected_(tenant_name_data: string) {
    try {
      let tenant_name = tenant_name_data;
      let tenants_list = this.tenants_list;
      let tenants_select = tenants_list.filter(
        (v) => <string | null>v.name == tenant_name,
      );
      if (tenants_select.length == 1) {
        return tenants_select[0].id;
      }
    } catch (error) {}
    return null;
  }

  loadTenantsMeter() {
    this.meterService.getTenants('public').subscribe({
      next: (response) => {
        if (response.meta.response_code == 20000) {
          try {
            this.tenants_list = response.meta.response_data;
            this.formMeter.patchValue({
              tenant_name: null,
            });
          } catch (error) {
            console.error(error);
          }
        }
      },
      error: (e) => {
        console.error(e);
      },
    });
  }

  loadLoops() {
    this.meterService.getLoops('list').subscribe({
      next: (response) => {
        if (response.meta.response_code == 20000) {
          try {
            let data = response.meta.response_data;
            this.loops_list = data;
          } catch (error) {
            console.error(error);
          }
        }
      },
      error: (e) => {
        console.error(e);
      },
    });
  }

  onDeleteMeter() {
    this.dialog
      .confirm({
        // requirePassword: true,
        // passwordConfig: {
        //   placeholder: 'รหัสผ่าน',
        //   required: true,
        // },
        iconConfig: {
          showBg: false,
        },
        icon: {
          type: 'img',
          src: 'assets/shared/icons/icon-ban.png',
        },
        title: 'view_value.title_delete_meter',
        message: ['view_value.sub_delete_msg', 'view_value.not_return_action'],
        confirm: {
          variant: 'danger',
        },
      })
      .pipe(
        filter(Boolean),
        switchMap(() => {
          let data = {
            meter_id: this.originalData.id,
            sensor_type: this.formMeter.value.type,
            // password
          };
          return this.dialog.withLoading(this.meterService.deleteMeter(data));
        }),
      )
      .subscribe({
        next: (responsedata) => {
          if (responsedata.meta.response_code == 20000) {
            this.toast.show({
              message: 'view_value.delete_meter_success',
              icon: 'error_circle',
              type: 'success',
            });
            this.dialogRef.close('updated');
          } else {
            this.toast.error('view_value.delete_meter_fail');
          }
        },
        error: (e) => {},
        complete: () => {},
      });
  }

  displayTenant(tenant: string): string {
    return tenant;
  }

  private filterTenant(data: string): Tenants[] {
    const filterValue = data.toLowerCase();
    return this.tenants_list.filter((option) =>
      option.name.toLowerCase().includes(filterValue),
    );
  }
  private getLoopId(name: string): number | null {
    const found = this.loops_list.find((l: any) => l.name === name);
    return found?.id || null;
  }

  private getPanelId(name: string): number | null {
    const found = name
      ? this.panels_list.find((p: any) => p.id === name)
      : null;
    return found?.id || null;
  }

  private mapTagIds(tags: any[]): number[] {
    if (!tags?.length) return [];

    return tags
      .map((t) => {
        if (typeof t === 'number') return t;

        const found = this.tags_list.find((tag) => tag.name === t);

        return found?.id;
      })
      .filter((id): id is number => typeof id === 'number');
  }

  private buildPayload(): UpdateNewMeter {
    const form = this.formMeter.value;

    const brandObj = this.brand_list.find(
      (b: any) => b.name === form.brand && b.id === form.model,
    );

    const payload: UpdateNewMeter = {
      id: this.data.id,

      name: form.name ?? '',
      meter_id: form.meter_id ?? 0,
      sensor_type: form.sensor_type ?? 'energy',
      module: form.module ?? '',

      loop_id: this.getLoopId(form.loop_name!) ?? 0,
      panel_id: this.getPanelId(form.panel!) ?? 0,
      brand_id: brandObj?.id ?? 0,
      location_id: this.getSelectedLocationId() ?? 0,

      tag_id: this.mapTagIds(form.tags!) ?? [],

      sub_meter_id: form.sub_meter_id ? Number(form.sub_meter_id) : null,
      type: form.type ?? undefined,
      serial_number: form.serial_number ?? undefined,
      description: form.description ?? undefined,
      install_date: undefined,
      billing_enabled: this.data.billing_enabled ?? undefined,
      tenant_id: this.tenants_id_selected ?? undefined,
    };

    return payload;
  }

  patchLocation(data: any) {
    // Build tier lists ก่อนทั้งหมด โดยไม่ต้อง subscribe valueChanges
    const tier1 = data.location_tier_1 || null;
    const tier2 = data.location_tier_2 || null;
    const tier3 = data.location_tier_3 || null;
    const tier4 = data.location_tier_4 || null;
    const tier5 = data.location_tier_5 || null;

    // Build tier 2 options จาก tier 1
    this.locationList.location_tier_2 = [
      ...new Set(
        this.allLocations
          .filter((d) => d.location_tier_1 === tier1)
          .map((d) => d.location_tier_2)
          .filter(Boolean),
      ),
    ];

    // Build tier 3 options จาก tier 2
    this.locationList.location_tier_3 = [
      ...new Set(
        this.allLocations
          .filter((d) => d.location_tier_2 === tier2)
          .map((d) => d.location_tier_3)
          .filter(Boolean),
      ),
    ];

    // Build tier 4 options จาก tier 3
    this.locationList.location_tier_4 = [
      ...new Set(
        this.allLocations
          .filter((d) => d.location_tier_3 === tier3)
          .map((d) => d.location_tier_4)
          .filter(Boolean),
      ),
    ];

    this.locationList.location_tier_5 = [
      ...new Set(
        this.allLocations
          .filter((d) => d.location_tier_4 === tier4)
          .map((d) => d.location_tier_5)
          .filter(Boolean),
      ),
    ];

    // Patch ทีเดียว emitEvent: false เพื่อไม่ให้ subscription reset ค่า
    this.formMeter.patchValue(
      {
        location_tier_1: tier1,
        location_tier_2: tier2,
        location_tier_3: tier3,
        location_tier_4: tier4,
        location_tier_5: tier5,
      },
      { emitEvent: false },
    );
    const tier4Control = this.formMeter.get('location_tier_4');
    const tier5Control = this.formMeter.get('location_tier_5');

    if (this.isLocationTier4Enabled() && tier3) {
      tier4Control?.enable({ emitEvent: false });
    } else {
      tier4Control?.disable({ emitEvent: false });
    }

    if (tier4) {
      tier5Control?.enable({ emitEvent: false });
    } else {
      tier5Control?.disable({ emitEvent: false });
    }

    // Trigger search controls ให้ filter re-emit
    this.locationTier1SearchCtrl.setValue('');
    this.locationTier2SearchCtrl.setValue('');
    this.locationTier3SearchCtrl.setValue('');
    this.locationTier4SearchCtrl.setValue('');
    this.locationTier5SearchCtrl.setValue('');
  }
}
